import React from 'react';
import { useState } from 'react';
import { useField } from 'formik';
import { FormGroup, Input, InputGroupText, FormFeedback, Label, InputProps } from 'reactstrap';
import { useTranslator } from '../I18n/useTranslator';

interface IFormikPasswordInputProps extends InputProps {
  label?: string;
  iconEye: string;
  iconEyeSlash: string;
  translateErrMsg?: boolean;
  name: string;
}

const FormikPasswordInput: React.FC<IFormikPasswordInputProps> = ({
  label,
  iconEye,
  iconEyeSlash,
  translateErrMsg = false,
  name,
  ...props
}) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input>. We can use field meta to show an error
  // message if the field is invalid and it has been touched (i.e. visited)
  const [field, meta] = useField({ name, type: 'password' });
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslator();

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <FormGroup className="mb-m">
      {label && <Label for={props.id || props.name}>{label}</Label>}
      <div className={`input-group-with-addon ${meta.touched && meta.error ? 'is-invalid' : ''}`}>
        <Input
          {...field}
          {...props}
          invalid={props.invalid || !!(meta.touched && meta.error)}
          type={isVisible ? 'text' : 'password'}
          data-test-id="password_input"
        />
        <InputGroupText onClick={toggleVisibility}>
          {isVisible ? (
            <img src={iconEye} alt="eye" data-test-id="eye_password_icon" />
          ) : (
            <img src={iconEyeSlash} alt="eye-slash" data-test-id="eye_password_icon" />
          )}
        </InputGroupText>
      </div>
      {meta.touched && meta.error && (
        <FormFeedback>{translateErrMsg ? t(meta.error) : meta.error}</FormFeedback>
      )}
    </FormGroup>
  );
};

export default FormikPasswordInput;
